import React, { useEffect, useState } from "react";
import { DefaultButton, Dropdown, Icon } from "@fluentui/react";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import PropTypes from "prop-types";
import { t } from "i18next";

const TablePagination = ({
  dataLength,
  page,
  gotoPage,
  canPreviousPage,
  pageOptions,
  pageSize,
  pageIndex,
  previousPage,
  nextPage,
  canNextPage,
  setPageSize,
  manualPageSize,
}) => {
  const rowsPerPage = [
    {
      key: 5,
      text: 5,
    },
    {
      key: 10,
      text: 10,
    },
    {
      key: 15,
      text: 15,
    },
  ];
  // console.log(pageOptions)
  const arrayPageIndexInitial =
    pageIndex - 2 < 0
      ? pageOptions.slice(0, pageIndex + 3)
      : pageOptions.slice(pageIndex - 1, pageIndex + 2);

  const [arrayPageIndex, setArrayPageIndex] = useState([]);

  const handleDropDownClick = (e) => {
    //setPageNumber(1);
    setPageSize(Number(+e.currentTarget.childNodes[0].innerText));
    // props.setselectedRowsPerPage(+e.currentTarget.childNodes[0].innerText);
  };

  useEffect(() => {
    // console.log(dataLength + " " + pageSize)
    if (Math.ceil(dataLength / pageSize) == 1) {
      setArrayPageIndex([0]);
    }
    if (Math.ceil(dataLength / pageSize) == 2) {
      setArrayPageIndex([0, 1]);
    }
    if (Math.ceil(dataLength / pageSize) > 2) {
      if (pageIndex === 0) {
        setArrayPageIndex([0, 1, 2]);
      } else if (canNextPage) {
        setArrayPageIndex([pageIndex - 1, pageIndex, pageIndex + 1]);
      } else if (!canNextPage) {
        setArrayPageIndex([pageIndex - 2, pageIndex - 1, pageIndex]);
      }
    }
  }, [dataLength, pageIndex, pageSize]);

  return (
    <>
      <div
        className="pagination-list-view"
        style={{
          flexDirection: isMobile ? "column" : "row",
          justifyContent: isMobile ? "center" : "space-between",
          height: "100%",
          width: "100%",
        }}
      >
        {/* <div className="pagination-rowCount" >
      <p>{t("statements.rows-per-page")} </p>
      {manualPageSize.map(item => (
                  <option className="pagination__item pagination__item-option" key={item} value={item}>
                    Show {item}
                  </option>
                ))}
      <Dropdown
        selectedKey={pageSize}
        options={rowsPerPage}
        onChange={(e) => handleDropDownClick(e)}
      />
    </div> */}
        <div className="pagination-pageCount">
          {/* <p className="pagination-pageCountElement">
      {pageSize * pageIndex + 1} - {pageSize * pageIndex + page.length} of {dataLength} {t("statements.enteries")}
      </p> */}

          <Icon
            iconName="ChevronLeft"
            className={`pagination-pageCountElement ${
              !canPreviousPage ? "pagination-disabled" : ""
            }`}
            onClick={previousPage}
          ></Icon>
          <div>
            <p
              className={`pagination-pageCountElement ${
                !canPreviousPage ? "pagination-disabled" : ""
              }`}
              onClick={() => gotoPage(0)}
            >
              {t("statements.first")}&nbsp;&nbsp;
            </p>
          </div>

          {arrayPageIndex.map((page, index) => {
            return (
              <DefaultButton
                key={index}
                className={`pagination-button pagination-pageCountElement ${
                  pageIndex === page ? "pagination-selected" : ""
                }`}
                text={page + 1}
                onClick={() => gotoPage(page)}
              />
            );
          })}
          <div>
            <p
              className={`pagination-pageCountElement ${
                !canNextPage ? "pagination-disabled" : ""
              }`}
              onClick={() => gotoPage(Math.ceil(dataLength / pageSize) - 1)}
            >
              &nbsp;&nbsp; {t("statements.last")}
            </p>
          </div>
          <Icon
            iconName="ChevronRight"
            className={`pagination-pageCountElement ${
              !canNextPage ? "pagination-disabled" : ""
            }`}
            onClick={nextPage}
          ></Icon>
        </div>
      </div>
    </>
  );
};

TablePagination.propTypes = {
  dataLength: PropTypes.number.isRequired,
  page: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  gotoPage: PropTypes.func.isRequired,
  canNextPage: PropTypes.bool.isRequired,
  canPreviousPage: PropTypes.bool.isRequired,
  pageOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  pageSize: PropTypes.number.isRequired,
  pageIndex: PropTypes.number.isRequired,
  previousPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  setPageSize: PropTypes.func.isRequired,
  manualPageSize: PropTypes.arrayOf(PropTypes.number),
};

TablePagination.defaultProps = {
  manualPageSize: [
    {
      key: 5,
      text: 5,
    },
    {
      key: 10,
      text: 10,
    },
    {
      key: 15,
      text: 15,
    },
  ],
};

export default TablePagination;
